import {Helper, Schema, FieldSet, SchemaResult} from 'simpli-web-sdk'
import {NotasInseridas} from '@/model/resource/NotasInseridas'

export class CsvNotasInseridasSemanalSchema extends Schema {
  readonly name = 'CsvNotasInseridas'

  readonly fieldSet: FieldSet<NotasInseridas> = {
    nomeFantasia: schema =>
      schema.model.responsavel && schema.model.responsavel.nomeFantasia
        ? schema.model.responsavel.nomeFantasia
        : schema.model.responsavel?.razaoSocial ?? '-',
    semana1: schema =>
      schema.model.qtdNotasSemanas && schema.model.qtdNotasSemanas[0],
    semana2: schema =>
      schema.model.qtdNotasSemanas && schema.model.qtdNotasSemanas[1],
    semana3: schema =>
      schema.model.qtdNotasSemanas && schema.model.qtdNotasSemanas[2],
    semana4: schema =>
      schema.model.qtdNotasSemanas && schema.model.qtdNotasSemanas[3],
    semana5: schema =>
      schema.model.qtdNotasSemanas && schema.model.qtdNotasSemanas[4],
  }
}
